/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import i18next from '@canvas/i18next'
import {localizeNumber} from '@canvas/i18next/localizeNumber'
import numberHelper from '@canvas/i18n/numberHelper'
import {configureGradeFormatting} from '@instructure/platform-grades'

const NS = 'sharedGradeFormatHelper'

export function up(): void {
  configureGradeFormatting({
    formatNumber: (value, options) => localizeNumber(value, options),
    parseNumber: input => numberHelper.parse(input),
    strings: {
      excused: i18next.t('Excused', {ns: NS}),
      complete: i18next.t('complete', {ns: NS}),
      incomplete: i18next.t('incomplete', {ns: NS}),
      scoreOutOf: '%{score}/%{pointsPossible}',
    },
  })
}
